<template>
  <transition
      enter-active-class="slide-in-right"
      leave-active-class="slide-out-right"
    >
    <div v-show="show" class="mb-answer-content">
      <mb-header title="答题卡" :back="closeAnswer"></mb-header>
      <div class="mb-progress-wrap">
        <div class="mb-progress" :style="`width:${parseInt(questionList.totalFinish / questionNum * 100)}%`"></div>
      </div>
      <div class="mb-top-nav">
        <span class="mb-left">已完成{{questionList.totalFinish}}题/共{{questionNum}}题</span>
        <div class="mb-right">
          <span><i class="mb-finish"></i>当前</span>
          <span><i class="mb-current"></i>已答</span>
          <span><i class="mb-not-yet"></i>未答</span>
        </div>
      </div>
      <div class="mb-scroll-box">
        <div class="mb-select-content" v-for="(t, i) in questionList.list" :key="i">
          <p class="mb-question-type">{{ formateType(t.typeId, t.questionType) }}</p>
          <ul class="mb-question-list">
            <li class="item"
                :class="{'is-finish': _t.isFinish, 'is-current': currentQuestionId === _t.id}"
                v-for="(_t, _i) in t.indexList"
                :key="_i" @click="selectQuestion(_t.id)">{{_t.index}}</li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import MbHeader from '@/components/MbHeader'
import eventBus from '@/utils/eventBus'
import { formateQuesType } from '@/utils/common'

export default {
  components: {
    MbHeader
  },
  props: {
    show: Boolean,
    questionList: {
      type: Object,
      default () {
        return {}
      }
    },
    questionNum: {
      type: Number,
      default: 0
    },
    totalScore: {
      type: Number,
      default: 0
    },
    progressWidth: {
      type: String,
      default: '0px'
    },
    currentQuestionId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    themeColor() {
      return this.$store.state.theme.themeColor
    },
    lightThemeColor() {
      return this.$store.state.theme.lightThemeColor
    }
  },
  methods: {
    closeAnswer() {
      this.$emit('toggleAnswer')
    },
    toggleHidden (index, status) {
      this.questionList.list[index].isHidden = !status
    },
    selectQuestion (id) {
      eventBus.$emit('selectQuestion', id)
      this.closeAnswer()
    },
    styleChange (e, _t, theme) {
      if (_t.isFinish || this.currentQuestionId === _t.id) return
      if (theme) {
        e.target.style = `border: 1px solid ${this.themeColor}`
      } else {
        e.target.style = `border: 1px solid ${this.lightThemeColor}`
      }
    },
    setStateStyle (_t) {
      let style = ''
      if (this.currentQuestionId === _t.id) {
        style = `border: 1px solid ${this.themeColor}color: #fff; background-color: ${this.themeColor}`
        return style
      }
      if (_t.isFinish) {
        style = `background-color: ${this.lightThemeColor}border: none; color: #666;`
        return style
      }
      return `border: 1px solid ${this.lightThemeColor}`
    },
    formateType(id, questionType = 5) {
      return formateQuesType(id, questionType)
    }
  }
}
</script>
<style lang="scss">
  @import '~@/assets/styles/animation.scss';
</style>
<style lang="scss" scoped>
.mb-progress-wrap{
  width: 100%;
  background: #F5F5F5;
  height: 8px;
  .mb-progress{
    background: #3D81FF;
    height: 100%;
  }
}
.mb-top-nav{
  height: 60px;
  background: #FFFFFF;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .mb-left{
    font-size: 24px;
    color: #999999;
  }
  .mb-right{
    font-size: 24px;
    color: #666666;
    display: flex;
    align-items: center;
    span{
      display: flex;
      align-items: center;
      &:not(:last-child){
        margin-right: 24px;
      }
      i{
        width: 24px;
        height: 24px;
        display: inline-block;
        border-radius: 4px;
        margin-right: 8px;
        &.mb-finish{
          background: #3D81FF;
        }
        &.mb-current{
          background: rgba(61, 129, 255, 0.1);
          border: 3px solid rgba(61, 129, 255, 0.5);
        }
        &.mb-not-yet{
          border: 3px solid #EDEEF7;
        }
      }
    }
  }
}
.mb-answer-content {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  animation-duration: 0.3s;
  .mb-scroll-box {
    position: relative;
    height: calc(100% - 156px);
    overflow-y: auto;
    padding-bottom: 50px;
    padding-top: 12px;
    background: #F5F5F5;
  }
}
.mb-select-content {
  padding-left: 25px;
  width: 100%;
  position: relative;
  background: #fff;
  padding: 0 40px;
  &:not(:last-child){
    margin-bottom: 8px;
  }
  .mb-question-type {
    line-height: 80px;
    font-size: 30px;
    font-weight: 500;
    color: #666666;
    border-bottom: 1px solid #F5F5F5;
  }
  .mb-question-list {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    align-items: center;
    margin-top: 24px;
    .item {
      position: relative;
      width: 112px;
      height: 112px;
      border-radius: 4px;
      border: 3px solid #EDEEF7;
      font-size: 36px;
      font-weight: 600;
      color: #666660;
      line-height: 112px;
      text-align: center;
      margin-bottom: 24px;
      margin-right: calc((100% - 560px) / 4);
      &:nth-of-type(5n) {
        margin-right: 0;
      }
      &.is-finish{
        background: rgba(61, 129, 255, 0.1);
        border-color: rgba(61, 129, 255, 0.5);
      }
      &.is-current{
        color: #fff;
        background: #3D81FF;
        border-color: #3D81FF;
      }
    }
  }
}

.slide-in-right {
  animation-name: slideInRight;
}

@keyframes slideInRight {
  0% {
    transform: translate3d(100vw, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

.slide-out-right {
  animation-name: slideOutRight;
}

@keyframes slideOutRight {
  0% {
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(100vw, 0, 0);
  }
}
</style>
